import React from "react";
import {Box, Typography} from "@mui/material";
import {colors} from "../../styling/GlobalTheme";
import Reveal from "./Reveal";

export default function SectionTitle({kicker, title, subtitle, light, action}: {
    kicker?: string; title: string; subtitle?: string; light?: boolean; action?: React.ReactNode;
}) {
    return (
        <Reveal>
            <Box sx={{display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 2, flexWrap: "wrap", mb: 4}}>
                <Box>
                    {kicker && <Typography sx={{color: light ? colors.glacier : colors.glacierDark, fontWeight: 800, letterSpacing: 2, textTransform: "uppercase", fontSize: ".8rem"}}>{kicker}</Typography>}
                    <Typography variant="h2" sx={{fontSize: {xs: "2.6rem", md: "3.6rem"}, color: light ? "#fff" : colors.night}}>{title}</Typography>
                    {subtitle && <Typography sx={{color: light ? "#aab4c5" : "text.secondary", mt: .5}}>{subtitle}</Typography>}
                </Box>
                {action}
            </Box>
        </Reveal>
    );
}
